import { useContext } from "react"
import { useCallback } from "react"
import { useEffect } from "react"
import { useState } from "react"
import { useNavigate, useParams } from "react-router-dom"
import Cookies from "universal-cookie"
import Spinner from "../Components/Spinner"
import UserContext from "../Context/UserContext"
import { addGuestToGroupDoc, countExibitorsDocWhereEvent, getEventDoc, getGroupDoc, getGroupsDocWhereExhibitorAndEvent, getGuestDoc, updateGuestDoc } from "../Requests/firebaseFirestore"
import { getFileBlob } from "../Requests/firebaseStorage"
import { sendGuestGiveawayNotification, sendGuestGroupAction } from "../Requests/sendMail"

export default function AddToGroup() {
  const {guestId} = useParams()
  const {user} = useContext(UserContext)
  const navigate = useNavigate()

  const [loading, setLoading] =useState(true)
  
  const [guest, setGuest] = useState({})
  const [groups, setGroups] = useState([])
  const [event, setEvent] = useState({})
  const [shortcut, setShortcut] = useState(false)
  
  const [groupsAdded, setGroupsAdded] = useState([])
  useEffect(()=>{
    document.body.className = document.body.className = 'bg-image'
  })

  const addVisit = useCallback (async(gst, uid, ev)=>{
    if(gst.visits){
      if(!gst.visits.includes(uid)){
        await updateGuestDoc(guestId, {visits:[...gst.visits, uid]})
        const exhs = await countExibitorsDocWhereEvent({name:ev.name, id:gst.event})

        let obj
        if(ev.visitObjective){
          obj = Math.round(parseFloat(ev.visitObjective))
        }else{
          obj = 70
        }

        let min = Math.round(exhs*(obj/100)-1)
        if(min === 0){
          min = 1
        }
        if(gst.visits.length === min){
            sendGuestGiveawayNotification({email:gst.email, event:ev})
        }
      }
    }else{
      await updateGuestDoc(guestId, {visits:[uid]})
    }
  },[user])

  const setInfo = async()=>{
    setLoading(true)
    const gst = await getGuestDoc(guestId)
    if(gst){
      setGuest(gst)
      const ev = await getEventDoc(gst.event)
      console.log(ev)
      setEvent(ev)
      let grps
      switch (user.role) {
        case 'organizer':
          const cookie = new Cookies()
          if(cookie.get('groupAddShortCut')){
            setShortcut(true)
            const grp = await getGroupDoc(cookie.get('groupAddShortCut'))
            let check = true
            grp.guests.forEach((g)=>{
              if(g.email === gst.email){
                check = false
              }
            })
            if(gst.event!==grp.event.id){
              check= false
            }
            if(check){
              const {allowShareData, company, email, fiscalId, location, name, phone, position} = gst
              await addGuestToGroupDoc(cookie.get('groupAddShortCut'), [...grp.guests, {allowShareData, company, email, fiscalId, location, name, phone, position}])
            }
            grps = [grp]
            setGroups([grp])
          }else{
            grps = await getGroupsDocWhereExhibitorAndEvent(user.uid, gst.event)
            setGroups(grps)  
          }
          break;
        case 'exhibitor':

          grps = await getGroupsDocWhereExhibitorAndEvent(user.uid, gst.event)
          await addVisit(gst, user.uid, ev)
          setGroups(grps)  
          break;
        case 'staff':
          grps = await getGroupsDocWhereExhibitorAndEvent(user.exhibitor.id, gst.event)
          await addVisit(gst, user.exhibitor.id)
          setGroups(grps)
          break;
        default:
          break;
      }
    }
    else{
      setGuest(false)
    }
    setLoading(false)
  }

  useEffect(()=>{
    if(user!=='checking'){
      if(user===false){
        navigate('/')
      }else{
        setInfo()
      }
    }
  }, [user])


  function blobToDataUrl(blob) {
    return new Promise(r => {let a=new FileReader(); a.onload=r; a.readAsDataURL(blob)}).then(e => e.target.result);
  }

  const handleAddToGroup = async (group) => {
    setGroupsAdded([...groupsAdded, group.id])
    const {allowShareData, company, email, fiscalId, location, name, phone, position} = guest
    await addGuestToGroupDoc(group.id, [...group.guests, {allowShareData, company, email, fiscalId, location, name, phone, position}])
    if(group.action.active){
      const attach = await getFileBlob(group.id)
      const dataUrl = await blobToDataUrl(attach)
      console.log(dataUrl)
      await sendGuestGroupAction({email:email, event:event, action:{...group.action, attachment:dataUrl}})
    }
  }

  return <div className="container mx-auto px-4">
    {loading?<>
    
    <div className="mx-auto mt-6"><Spinner/></div>
    </>:<>
    {guest?
    <>
    <h1 className="text-white font-semibold text-3xl py-2 mx-auto text-center">{event.name}</h1>
    {shortcut?
      <h1 className="text-white font-semibold text-xl py-2 mx-auto text-center">Se agregó a {guest.name} al grupo {groups[0].name}</h1>
    :
    <>
    <h1 className="text-white font-semibold text-xl py-2 mx-auto text-center">Agregar a {guest.name} a un grupo</h1>
    <div className="grid grid-cols-1 gap-4 w-[300px] mx-auto justify-center">
    {groups.map((group, index)=>{
      let disabled = false
      group.guests.forEach(gst => {
        if(gst.email === guest.email){
          disabled = true
        }
      });
      groupsAdded.forEach((id)=>{
        if(id===group.id){
          disabled = true
        }
      })
      return(
        <button onClick={()=>{handleAddToGroup(group)}} key={index} className="group-select-btn" disabled={disabled}>
        <h1 className="flex items-center gap-2">{group.name}</h1>
      </button>
      )
    })}
    </div>
    </>
    }
    </>:
        <h1 className="text-white text-center mt-4 font-semibold text-xl py-2">No se encontró al asistente.</h1>

    }
    </>}
  </div>
}